(() => {
  const storefrontRoot = () => window.Shopify?.routes?.root || '/';
  const localizedPath = (path) => {
    const value = String(path || '');
    return `${storefrontRoot()}${value.startsWith('/') ? value.slice(1) : value}`;
  };
  const SET_HUB_PATH = localizedPath('pages/keramik-sets').replace(/\/$/, '');
  const BRICK_HANDLES = [
    'myromy-bbq-brick-mini-brater-duo-2er-set',
    'myromy-brick-classic-bbq-signature-edition-duo-2er-set',
    'myromy-brick-bbq-signature-edition-4er-set',
    'myromy-brick-bbq-set-2-bricks-coffee',
    'myromy-brick-classic-bbq-mix-set-coffee',
    'myromy-brick-bbq-set-4-bricks-coffee'
  ];

  const withPreview = (path) => {
    const url = new URL(path, window.location.origin);
    const current = new URLSearchParams(window.location.search);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.has(key)) url.searchParams.set(key, current.get(key));
    });
    return `${url.pathname}${url.search}`;
  };

  const ensureStyles = () => {
    if (document.getElementById('myromy-approved-setworld-gateway-styles')) return;
    const style = document.createElement('style');
    style.id = 'myromy-approved-setworld-gateway-styles';
    style.textContent = `
      .myromy-typefinder__card {
        display: grid !important;
        grid-template-rows: auto 1fr auto;
        align-content: start;
        min-height: 290px;
      }
      .myromy-typefinder__card > span:nth-child(2),
      .myromy-typefinder__title,
      .myromy-typefinder__text { display: block; }
      .myromy-typefinder__title { margin-bottom: 10px !important; }
      .myromy-typefinder__number { font-weight: 600; }
      .myromy-typefinder__arrow {
        align-self: end !important;
        justify-self: stretch;
        display: flex;
        justify-content: space-between;
        gap: 12px;
        margin-top: 24px;
        font-size: .84rem !important;
        letter-spacing: .02em;
      }

      .mse-home-entry-title > a {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
        text-decoration: none;
      }
      .mse-home-entry-title__world {
        display: block;
        max-width: 100%;
        white-space: nowrap;
        font-family: var(--heading-font-family);
        font-weight: var(--heading-font-weight);
        font-style: var(--heading-font-style);
        font-size: 14px;
        line-height: 1.15;
        text-transform: none;
      }
      .mse-home-entry-title__variant {
        display: block;
        font-family: var(--text-font-family);
        font-weight: var(--text-font-weight);
        font-style: var(--text-font-style);
        font-size: 12px;
        line-height: 1.25;
        letter-spacing: .05em;
        text-transform: none;
        opacity: .68;
      }

      @media screen and (min-width: 1100px) {
        .mse-setworld-products .mse-product-grid[data-count="6"] {
          display: grid !important;
          grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
          gap: 20px !important;
          max-width: 1180px !important;
        }
        .mse-setworld-products .mse-product-grid[data-count="6"] > .mse-product-card {
          flex: none !important;
          width: auto !important;
          max-width: none !important;
        }
      }
      @media screen and (min-width: 750px) and (max-width: 1099px) {
        .mse-setworld-products .mse-product-grid[data-count="6"] {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 18px !important;
        }
        .mse-setworld-products .mse-product-grid[data-count="6"] > .mse-product-card {
          flex: none !important;
          width: auto !important;
          max-width: none !important;
        }
      }

      @media screen and (max-width: 699px) {
        .myromy-typefinder__grid {
          display: flex !important;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scrollbar-width: none;
          gap: 12px;
          padding-bottom: 4px;
        }
        .myromy-typefinder__grid::-webkit-scrollbar { display: none; }
        .myromy-typefinder__card {
          flex: 0 0 min(82vw, 330px);
          min-height: 300px !important;
          scroll-snap-align: start;
        }
        .mse-home-entry-title__world { font-size: 12px; }
        .mse-home-entry-title__variant { font-size: 11px; }
      }
    `;
    document.head.appendChild(style);
  };

  const applyGateway = () => {
    const root = document.querySelector('.myromy-typefinder');
    if (!root) return;
    root.querySelectorAll('.myromy-typefinder__card[href]').forEach((card) => {
      card.href = withPreview(card.getAttribute('href'));
    });
    document.documentElement.dataset.myromyApprovedSetworldGateway = 'native-copy';
  };

  const isSetHub = () => window.location.pathname.replace(/\/$/, '') === SET_HUB_PATH;


  const linkBrickCards = () => {
    if (!isSetHub()) return;
    const section = document.querySelector('[id$="__brick_products"]');
    if (!section) return;
    const cards = Array.from(section.querySelectorAll('.mse-product-card'));
    cards.slice(0, BRICK_HANDLES.length).forEach((card, index) => {
      const handle = BRICK_HANDLES[index];
      const href = withPreview(localizedPath(`products/${handle}`));
      card.dataset.mseBrickHandle = handle;

      const media = card.querySelector('.mse-product-card__image');
      if (media) {
        if (media.tagName === 'A') {
          media.href = href;
        } else {
          const mediaLink = document.createElement('a');
          mediaLink.className = media.className;
          mediaLink.href = href;
          const brickTitle = (card.querySelector('h3')?.textContent || 'Brick Set').trim();
          const viewPattern = window.myromyQ4?.setViewLabelPattern || '[title] ansehen';
          mediaLink.setAttribute('aria-label', viewPattern.replace('[title]', brickTitle));
          while (media.firstChild) mediaLink.appendChild(media.firstChild);
          media.replaceWith(mediaLink);
        }
      }

      const heading = card.querySelector('h3');
      if (heading) {
        let titleLink = heading.querySelector('a');
        if (!titleLink) {
          titleLink = document.createElement('a');
          titleLink.textContent = heading.textContent.trim();
          heading.replaceChildren(titleLink);
        }
        titleLink.href = href;
      }

      const cta = card.querySelector('.mse-card-cta');
      if (cta) {
        if (cta.tagName === 'A') {
          cta.href = href;
        } else {
          const ctaLink = document.createElement('a');
          ctaLink.className = cta.className;
          ctaLink.href = href;
          ctaLink.textContent = cta.textContent;
          cta.replaceWith(ctaLink);
        }
      }
    });
    document.documentElement.dataset.myromyBrickCardLinks = 'image-title-cta';
  };

  const run = () => {
    ensureStyles();
    applyGateway();
    linkBrickCards();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  setTimeout(run, 250);
  setTimeout(run, 800);
  document.addEventListener('shopify:section:load', run);
})();
